import { render, staticRenderFns } from "./PayrollUpload.vue?vue&type=template&id=1435cd3c"
import script from "./PayrollUpload.vue?vue&type=script&lang=ts"
export * from "./PayrollUpload.vue?vue&type=script&lang=ts"
import style0 from "./PayrollUpload.vue?vue&type=style&index=0&id=1435cd3c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports